import { render, staticRenderFns } from "./BuilderSidebar.vue?vue&type=template&id=64626810&scoped=true&"
import script from "./BuilderSidebar.vue?vue&type=script&lang=js&"
export * from "./BuilderSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BuilderSidebar.vue?vue&type=style&index=0&id=64626810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64626810",
  null
  
)

export default component.exports